module.exports = __webpack_public_path__ + "assets/2370be164319efe3d5b9b0f409a68e36.png";